import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../../context/AppContext";
import PortalWrapper from "./PortalWrapper";
import "./Pop.css";

const EditProfilePop = ({ onClose, userProfile, onSave }) => {
  const { token } = useContext(AppContext);

  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    phone: "",
    fav_number: "",
    foot: "",
    position: "",
    bio: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true); // حالة التحميل

  useEffect(() => {
    if (userProfile && Object.keys(userProfile).length > 0) {
      setFormData({
        name: userProfile.name || "",
        username: userProfile.username || "",
        email: userProfile.email || "",
        phone: userProfile.phone || "",
        fav_number: userProfile.fav_number || "",
        foot: userProfile.foot || "",
        position: userProfile.position || "",
        bio: userProfile.bio || ""
      });
      setLoading(false); // تم تحميل البيانات
    }
  }, [userProfile]);

  const handleChanges = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://dashboard.tiktaka.com/api/updateUserProfile",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify(formData)
        }
      );

      const data = await response.json();

      if (response.ok) {
        alert(data.message);
          await onSave();
        onClose();
        window.location.reload();

      } else if (response.status === 422) {
        setErrors(data.errors);
      } else {
        alert("Update failed");
      }
    } catch (err) {
      alert("Something went wrong");
    }
  };

  if (!userProfile) {
  return (
    <PortalWrapper>
      <div className="popup-overlay">
        <p>Loading...</p>
      </div>
    </PortalWrapper>
  );
}else{
  return (
    <PortalWrapper>
  
        <div className="popup-overlay">
          <div className="popup-panel">
            <div className="panel-header">
              <button onClick={onClose}>✖</button>
            </div>
            <div className="panel-body loginBox">
              <form onSubmit={handleSubmit} className="material-form">
                <div className="input-field">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChanges}
                  />
                  <label>Name*</label>
                  <span className="bar"></span>
                  {errors.name && <div className="errorMessage">{errors.name[0]}</div>}
                </div>
  
                <div className="input-field">
                  <input
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleChanges}
                  />
                  <label>Username*</label>
                  <span className="bar"></span>
                  {errors.username && (
                    <div className="errorMessage">{errors.username[0]}</div>
                  )}
                </div>
  
                <div className="input-field">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChanges}
                  />
                  <label>Email*</label>
                  <span className="bar"></span>
                  {errors.email && (
                    <div className="errorMessage">{errors.email[0]}</div>
                  )}
                </div>
  
                <div className="input-field">
                  <input
                    type="number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChanges}
                  />
                  <label>Phone*</label>
                  <span className="bar"></span>
                  {errors.phone && (
                    <div className="errorMessage">{errors.phone[0]}</div>
                  )}
                </div>


                <div className="input-field">

                  <input type="radio" name='foot' className='inputradio' id='rightFoot' style={{ display:'inline', width:'auto', height:'auto', marginLeft:'20px'}} checked={formData.foot === 'left'}  value="left" onChange={handleChanges} />
                  <span style={{ marginRight:'20px' }}> L-Foot</span>
                  <input type="radio" name='foot' className='inputradio' id='leftFoot' style={{ display:'inline-block', width:'auto', height:'auto' }} checked={formData.foot === 'right'}  value="right" onChange={handleChanges}  />
                  <span style={{ marginRight:'20px' }}> R-Foot</span>


                  <label>Foot*</label>
                  <span className="bar"></span>
                  {errors.foot && <div className="errorMessage">{errors.foot[0]}</div>}
                </div>



            <div className="input-field">
                  <select name="position" className='inputField' value={formData.position} onChange={handleChanges} >
                    <option value="gk" >GK</option>
                    <option value="CB">CB</option>
                    <option value="RB">RB</option>
                    <option value="LB">LB</option>
                    <option value="CDM">CDM</option>
                    <option value="CM">CM</option>
                    <option value="CAM">CAM</option>
                    <option value="LW">LW</option>
                    <option value="RW">RW</option>
                    <option value="SS">SS</option>
                    <option value="CF">CF</option>
                    <option value="ST">ST</option>
                  </select>
                  <label>Position</label>
                  <span className="bar"></span>
                  {errors.position && <div className="errorMessage">{errors.position[0]}</div>}
            </div>

              <div className='input-field'>
                        <input type='number' placeholder='Favourite Number' name='fav_number'  value={formData.fav_number}
                                onChange={handleChanges} ></input>
                        <label>favourite Number</label>
                        <span className="bar"></span>
                        {errors.fav_number && (
                                <div style={{ color: "red", fontSize: "12px" }}>
                                {errors.fav_number[0]}
                                </div>
                        )}
                </div>
          

  
                <div className="input-field">
                  <textarea
                    name="bio"
                    cols="30"
                    rows="10"
                    placeholder="enter your bio"
                    value={formData.bio}
                    onChange={handleChanges}
                  ></textarea>
                  <label>Bio</label>
                  <span className="bar"></span>
                </div>
  
                <button type="submit">Submit</button>
              </form>
            </div>
          </div>
        </div>
      
    </PortalWrapper>
  );

}

};

export default EditProfilePop;
